import { NavLink, useLocation } from 'react-router-dom';
import { Home, MessageCircle, Search, User, LayoutDashboard } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { useLang } from '@/lib/i18n';

export const BottomNav = () => {
  const { user } = useAuth();
  const { t } = useLang();
  const location = useLocation();
  if (!user) return null;
  // Hide on auth pages
  if (/^\/(login|signup|verify|forgot-password)/.test(location.pathname)) return null;

  const items = [
    { to: '/', icon: Home, label: t('nav.home'), testid: 'bottomnav-home' },
    { to: '/search', icon: Search, label: t('nav.search'), testid: 'bottomnav-search' },
    { to: '/messages', icon: MessageCircle, label: t('nav.messages'), testid: 'bottomnav-messages' },
    { to: '/dashboard', icon: LayoutDashboard, label: t('nav.dashboard.short'), testid: 'bottomnav-dashboard' },
    { to: '/profile', icon: User, label: t('nav.profile.short'), testid: 'bottomnav-profile' },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-[#E2E8F0] z-40 safe-bottom" data-testid="bottom-nav">
      <div className="grid grid-cols-5 h-16">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            data-testid={it.testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[10px] font-medium ${isActive ? 'text-[#1677F2]' : 'text-slate-600'}`
            }
          >
            {({ isActive }) => (
              <>
                <it.icon size={22} strokeWidth={isActive ? 2.4 : 2} />
                <span>{it.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
